module.exports = __webpack_public_path__ + "fonts/HelveticaNeue-ExtraLight.863ad7e-1.2.11.woff";